import { Link } from "react-router-dom";
import { Alert, Button } from "@marekl/adminer/components";
import { useMe } from "../../auth/queries";
import { useSeason } from "../../season";
import { useTeam } from "../../lib/queries/teams";
import {
  SEASON_REGISTRATION_BLOCKED,
  seasonRegistrationAccess,
} from "../../lib/entryEligibility";
import type { ID } from "../../lib/id";

/**
 * Why a team cannot file a přihláška to an MČR start, and the way out.
 *
 * Shown wherever a leader would otherwise just meet a missing „Nová
 * přihláška": the Soutěže cards and a competition's přihlášky page. The
 * wizard, which is linkable, has its own guard screen.
 *
 * The button is offered only where it leads somewhere. SeasonRegistrationPage
 * redirects anyone who may not manage the team, and a leader outside the
 * registration window, so the sentence names who can still help instead.
 */
export function SeasonRegistrationNotice({ teamId }: { teamId: ID }) {
  const { data: me } = useMe();
  const { activeSeason } = useSeason();
  const { data: team } = useTeam(teamId);
  const access = seasonRegistrationAccess(activeSeason, me, teamId, team?.federation_id);
  return (
    <Alert
      variant="warn"
      title={
        activeSeason
          ? `Tým nemá v sezóně ${activeSeason.code} žádné registrované členy`
          : "Tým nemá žádné registrované členy"
      }
      action={
        access === "open" ? (
          <Link to={`/teams/${teamId}/registrace`}>
            <Button variant="primary">Registrace do sezóny</Button>
          </Link>
        ) : undefined
      }
    >
      Na kvalifikační kola a finále MČR se může přihlásit jen tým s registrovanými členy; na
      pohárovky se tým přihlásí i bez registrace.
      {access !== "open" && ` ${SEASON_REGISTRATION_BLOCKED[access]}`}
    </Alert>
  );
}
